<div class="switch-panel" [class.highlight]="value" [class.disabled]="disabled">
  <div class="switch-panel__left" (click)="toggle()">
    <div class="switch-panel__switch">
      <span class="switch-panel__handle"></span>
    </div>
  </div>
  <div class="switch-panel__right">
    @if (label) {
      <div class="switch-panel__label">{{ label }}</div>
    }

    @if (activeText) {
      <div class="switch-panel__text">{{ value ? activeText : text }}</div>
    } @else if (text) {
      <div class="switch-panel__text">{{ text }}</div>
    }

    <ng-content></ng-content>
  </div>
</div>
